import { createRouter, createWebHistory } from 'vue-router'

// Importar componentes
import Inicio from '@/pages/Inicio.vue'
import Yo from '@/pages/Yo.vue'
import Contacto from '@/pages/Contacto.vue'
import Servicios from '@/pages/Servicios.vue'
import Ejemplos from '@/pages/Ejemplos.vue'
import D_ModoClaroOscuro from '@/pages/Demos/D-ModoClaroOscuro.vue'
// ✅ EJEMPLO: Cómo importar un nuevo componente
import D_Responsive from '@/pages/Demos/D-Responsive.vue'
// EJEMPLO para futuros: import D_NuevoComponente from '@/pages/Demos/D-NuevoComponente.vue'

import AdminL2 from '@/pages/AdminL2.vue'
import PageDisabled from '@/pages/PageDisabled.vue'
import MaintencePage from '@/pages/MaintencePage.vue'

const routes = [
  // ✅ RUTAS PRINCIPALES
  { path: '/', component: Inicio, name: 'inicio' },
{ path: '/Yo', component: Yo, name: 'yo' },
{ path: '/Contacto', component: Contacto, name: 'contacto' },
{ path: '/Servicios', component: Servicios, name: 'servicios' },
{ path: '/Ejemplos', component: Ejemplos, name: 'ejemplos' },

// ✅ EJEMPLO: Ruta con parámetros dinámicos
{
  path: '/demos/:demoId',
  name: 'demo',
  component: D_ModoClaroOscuro
},

// ✅ EJEMPLO: Rutas específicas para demos
{
  path: '/Demo_ClaroOscuro',
  component: D_ModoClaroOscuro,
  name: 'demo-claro-oscuro'
},
// ✅ EJEMPLO: Cómo agregar una nueva ruta de demo
{
  path: '/demos/responsive-control',
  component: D_Responsive,
  name: 'demo-responsive'
},
// EJEMPLO para futuros:
// {
//   path: '/Demo_Nuevo',
//   component: D_NuevoComponente,
//   name: 'demo-nuevo'
// },

// ✅ RUTAS DEL SISTEMA
{
  path: '/adminl2',
  name: 'adminl2',
  component: AdminL2,
  meta: { requiresAuth: false }
},
{
  path: '/page-disabled',
  name: 'page-disabled',
  component: PageDisabled,
  meta: { requiresAuth: false }
},
{
  path: '/maintenance',
  name: 'maintenance',
  component: MaintencePage,
  meta: { requiresAuth: false }
},

// ✅ EJEMPLO: Ruta 404 - Página no encontrada
// {
//   path: '/:pathMatch(.*)*',
//   name: 'not-found',
//   component: PaginaNoEncontrada
// }
]

const router = createRouter({
  history: createWebHistory(),
                            routes
})

// ✅ Interceptación de rutas para mantenimiento y páginas bloqueadas
router.beforeEach(async (to:any, from:any, next:any) => {
  try {
    // Verificar modo mantenimiento
    const maintenanceResponse = await fetch('http://localhost:5000/api/check-maintenance')
    const maintenanceData = await maintenanceResponse.json()

    // Si está en mantenimiento y no va a maintenance o admin, redirigir
    if (maintenanceData.maintenance_mode &&
      !to.path.includes('/adminl2') &&
      to.path !== '/maintenance') {
      next('/maintenance')
      return
      }

      // Verificar páginas bloqueadas
      if (!to.path.includes('/adminl2') &&
        to.path !== '/maintenance' &&
        to.path !== '/page-disabled' &&
        to.path !== '/') {
        const path = to.path
        const pageCheckResponse = await fetch(`http://localhost:5000/api/check-page-access${path}`)
        const pageData = await pageCheckResponse.json()

        if (pageData.blocked) {
          next('/page-disabled')
          return
        }
        }

        next()
  } catch (error) {
    console.error('Error en verificación de ruta:', error)
    next()
  }
})

export default router
